module.exports = __webpack_public_path__ + "img/T5-A-xh_3.40aebf75.png";